import styled, { css } from 'styled-components';

export const ButtonHidden = styled.button`
  background: transparent;
  border: none;
  padding-top: 0;
  margin-top: 0;
`;

export const Container = styled.div`
  background-color: ${props => props.theme.colors.white};
  border-radius: 8px;
  padding: ${props => props.theme.global.gutterSpace * 1.25}px;
  max-width: ${props => props.maxWidth || 350}px;
  font-weight: 500;
  font-size: ${props => props.theme.fontSizes[2]};
`;

export const Footer = styled.div`
  padding-top: ${props => props.theme.global.gutterSpace * 1.25}px;
  display: flex;
  justify-content: flex-end;
`;
